"use client";

import { c as _c } from "react/compiler-runtime";
import AppButton from "./AppButton";
import Container from "../wrapper/Container";
import Logo from "../common/navigation/Logo";
import NavMenu from "../global/NavMenu";
import { useEffect, useState } from "react";
import { useCalBooking } from "@/providers/booking/CalBookingProvider";
const Header = () => {
  const $ = _c(17);
  const {
    enabled: calEnabled,
    goToBooking
  } = useCalBooking();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isMobileOpen) {
    t0 = () => {
      if (isMobileOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return _temp;
    };
    t1 = [isMobileOpen];
    $[0] = isMobileOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Logo />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isMobileOpen) {
    t3 = () => setIsMobileOpen(!isMobileOpen);
    $[4] = isMobileOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsMobileOpen(false);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isMobileOpen || $[8] !== t3) {
    t5 = <NavMenu scrolled={false} isMobileOpen={isMobileOpen} onMobileToggle={t3} onMobileClose={t4} />;
    $[7] = isMobileOpen;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = calEnabled ? goToBooking : undefined;
  const t7 = calEnabled ? undefined : "/contact";
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="w-3 h-3 bg-black rounded-full" />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t7) {
    t9 = <div className="hidden lg:block shrink-0"><AppButton onClick={t6} href={t7} className="w-36" buttonClass="h-10" shadowClass="-translate-x-1 translate-y-1">{t8}Book Now</AppButton></div>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t9) {
    t10 = <><header className="relative w-full py-4 z-40"><Container className="flex items-center justify-between px-4 lg:px-10">{t2}{t5}{t9}</Container></header></>;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
export default Header;
function _temp() {
  document.body.style.overflow = "";
}